import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { services } from "@/data/services";

export default function ServicesPage() {
  useEffect(() => {
    document.title = "Wildlife Removal Services | Double D Trapping LLC | St. Augustine, FL";
  }, []);

  return (
    <>
      {/* Page Header */}
      <section className="bg-[#0F1A15] border-b border-[#1F2937] py-16 sm:py-20" data-testid="services-page-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#D95D39] uppercase text-xs font-bold tracking-[0.2em] mb-4">What We Do</p>
          <h1 className="text-[#F8FAFC] font-black text-4xl sm:text-5xl tracking-tighter mb-4" data-testid="services-page-title">
            Wildlife Removal Services
          </h1>
          <p className="text-[#9CA3AF] text-base sm:text-lg max-w-2xl leading-relaxed">
            From raccoons in your attic to wild hogs on your property — we handle it all. 50 years of experience. Licensed, insured, and guaranteed.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="bg-[#0B110E] py-16 sm:py-20" data-testid="services-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-6">
            {services.map((s, i) => (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="service-card group border border-[#1F2937] rounded-sm overflow-hidden bg-[#0F1A15] flex flex-col md:flex-row"
                data-testid={`services-list-${s.slug}`}
              >
                <div className="md:w-80 lg:w-96 shrink-0 aspect-[16/10] md:aspect-auto overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover opacity-70 group-hover:opacity-90 transition-opacity duration-300"
                    loading="lazy"
                  />
                </div>
                <div className="p-6 sm:p-8 flex flex-col justify-center flex-1">
                  <p className="text-[#D95D39] text-xs font-bold tracking-[0.2em] uppercase mb-2">{s.tagline}</p>
                  <h2 className="text-[#F8FAFC] font-black text-xl sm:text-2xl tracking-tight mb-3">{s.title}</h2>
                  <p className="text-[#9CA3AF] text-sm leading-relaxed mb-4 line-clamp-3">{s.shortDesc}</p>
                  {s.featured && (
                    <div className="inline-flex items-center gap-2 bg-[#D95D39]/10 border border-[#D95D39]/30 text-[#D95D39] text-xs font-bold px-3 py-1.5 rounded-sm mb-4 w-fit">
                      FEDERALLY LICENSED
                    </div>
                  )}
                  <span className="inline-flex items-center gap-1.5 text-[#D95D39] text-xs font-bold uppercase tracking-wider group-hover:gap-2.5 transition-[gap] duration-150 w-fit">
                    View Service Details <ArrowRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0F1A15] border-t border-[#1F2937] py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-[#F8FAFC] font-black text-2xl sm:text-3xl tracking-tighter mb-4">
            Not Sure What You're Dealing With?
          </h2>
          <p className="text-[#9CA3AF] text-sm sm:text-base mb-8">
            Call us. Describe what you're hearing or seeing. We'll figure it out and get it handled.
          </p>
          <a href="tel:9042376253" data-testid="services-cta-call">
            <button className="bg-[#D95D39] hover:bg-[#c04d2d] text-white font-black uppercase tracking-widest text-sm px-8 py-4 rounded-sm btn-glow inline-flex items-center gap-3 transition-colors duration-150">
              <Phone className="w-5 h-5" />
              Call 904-237-6253
            </button>
          </a>
        </div>
      </section>
    </>
  );
}
